import React from 'react';
import { UploadedPointContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Displays, Inputs, Tables } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import * as XLSX from 'xlsx';
import moment from 'moment';
import 'moment-timezone';
import { RenderCommaMoney } from 'utils/functions/FormatMoney';
import {
  parseFilterQuery,
  syncFilterUrlQuery,
} from 'utils/functions/filterQuery';

// status ไม่อยู่ในนี้ เพราะหน้านี้บังคับ status=1 เสมอ
const FILTER_FIELDS = [
  'user_id',
  'customer_cu_id',
  'campaign_code',
  'start_date',
  'end_date',
];

class UploadedPointContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    // เปลี่ยน key เพื่อบังคับสร้าง InputFilter ใหม่ตอนกดล้างค่า
    filterKey: 0,
    ...parseFilterQuery(this.props.router.location.search, FILTER_FIELDS),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_UPLOADED_POINT_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseFilterQuery(e, FILTER_FIELDS);
    this.setState({ ...parsedQuery });
    this.handleJoinQuery(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseFilterQuery('', FILTER_FIELDS),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    // status=1 ต่อท้ายเสมอและไม่เอาขึ้น url
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}&status=1`
      : `?limit=${perPage}&page=${page}&status=1`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    syncFilterUrlQuery(this.props.router, query, page);
    this.fetchData(joinQuery);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false&status=1`
      : `?pagination=false&status=1`;
    let res = await portalService.GET_UPLOADED_POINT_LIST(joinQuery);
    if (res && res.status === 200) {
      var wb = XLSX.utils.book_new();
      var ws_name = 'SheetJS';
      /* make worksheet */
      var ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          moment(e.updated_at).tz('Asia/Bangkok').format('DD/MM/YYYY'),
          e.customer_user_id,
          moment(e.created_at).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
          e.customer_cu_id,
          e.campaign_code,
          RenderCommaMoney(Number(e.so_amount), true),
          RenderCommaMoney(Number(e.point), true),
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        'No',
        'Updated date',
        'Login ID',
        'Created at',
        'CU code',
        'Campaign code',
        'SO amount',
        'Point',
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wscols = [
        { wch: 5 },
        { wch: 15 },
        { wch: 35 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];
      ws['!cols'] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `Uploaded point report ${moment()
          .tz('Asia/Bangkok')
          .format('DD/MM/YYYY')}.xlsx`
      );

      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleChangeOutputType = (e) => {
    this.setState({
      outputTypeCurrent: e,
    });
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      pagination,
      data,
      filterValues,
      filterKey,
    } = this.state;
    return (
      <UploadedPointContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="418px" />
        ) : (
          <Tables.Standard
            columns={columns}
            data={data}
            showPagination
            pagination={pagination}
            handlePageClick={this.handlePageClick}
          />
        )}
      </UploadedPointContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: 'user_id',
    length: '250px',
    filter: {
      fieldQuery: 'user_id',
      type: 'text',
      defaultValue: filterValues.user_id,
      label: 'Login ID : ',
      placeholder: 'Login ID',
    },
  },
  {
    accessor: 'customer_cu_id',
    length: '200px',
    filter: {
      fieldQuery: 'customer_cu_id',
      type: 'text',
      defaultValue: filterValues.customer_cu_id,
      label: 'CU code : ',
      placeholder: 'CU code',
    },
  },
  {
    accessor: 'campaign_code',
    length: '200px',
    filter: {
      fieldQuery: 'campaign_code',
      type: 'text',
      defaultValue: filterValues.campaign_code,
      label: 'Campaign code : ',
      placeholder: 'Campaign code',
    },
  },
  {
    accessor: 'date',
    filter: {
      fieldQuery: 'date',
      type: 'dateRank',
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: 'Date Range : ',
    },
  },
];

const columns = [
  {
    Header: <div style={{ textAlign: 'left' }}>Updated date</div>,
    accessor: 'updated_at',
    Cell: (props) => (
      <div>{moment(props.value).tz('Asia/Bangkok').format('DD/MM/YYYY')}</div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Login ID</div>,
    accessor: 'customer_user_id',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Created at</div>,
    accessor: 'created_at',
    Cell: (props) =>
      moment(props.value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>CU code</div>,
    accessor: 'customer_cu_id',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Campaign code</div>,
    accessor: 'campaign_code',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>SO amount</div>,
    accessor: 'so_amount',
    Cell: (props) => RenderCommaMoney(Number(props.value), true),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Point</div>,
    accessor: 'point',
    Cell: (props) => RenderCommaMoney(Number(props.value), true),
  },
];

export default withRouter(UploadedPointContainer);
